__turbopack_context__.v({
  "cellLabel": "MatrixQuestion-module__rj-Siq__cellLabel",
  "columnLabel": "MatrixQuestion-module__rj-Siq__columnLabel",
  "matrixContainer": "MatrixQuestion-module__rj-Siq__matrixContainer",
  "matrixStack": "MatrixQuestion-module__rj-Siq__matrixStack",
  "matrixTable": "MatrixQuestion-module__rj-Siq__matrixTable",
  "optionCell": "MatrixQuestion-module__rj-Siq__optionCell",
  "optionsRow": "MatrixQuestion-module__rj-Siq__optionsRow",
});
